export const ROUTE_MAP: Record<string, string> = {
  "AdmSelectivityDataScript": "/adm-selectivity-data-script",
  "BrigadaExternaCombo": "/brigada-externa-combo",
  "BrigadaInternaCombo": "/brigada-interna-combo",
  "Celda": "/celda",
  "ComboFiltroListadoEstadisticas": "/combo-filtro-listado-estadisticas",
  "DispositivoScript": "/dispositivo-script",
  "DispositivosUltimaHora": "/dispositivos-ultima-hora",
  "IHObtenerUltimoEstado": "/ih-obtener-ultimo-estado",
  "IHSentenciasCalculoHoras": "/ih-sentencias-calculo-horas",
  "Inicio": "/inicio",
  "IntfTablesForREprocessing": "/intf-tables-for-r-eprocessing",
  "ListadoAvisosMedioambientalesEdicion": "/listado-avisos-medioambientales-edicion",
  "ListadoBrigadasPorBrigadaEx": "/listado-brigadas-por-brigada-ex",
  "ListadoBrigadasPorBrigadaIn": "/listado-brigadas-por-brigada-in",
  "ListadoBrigadasPorSector": "/listado-brigadas-por-sector",
  "ListadoBrigadasPorUtd": "/listado-brigadas-por-utd",
  "ListadoBrigadasPorZona": "/listado-brigadas-por-zona",
  "ListadoDispositivoConOpPenAnalizar": "/listado-dispositivo-con-op-pen-analizar",
  "ListadoDispositivosGeneralEdicion": "/listado-dispositivos-general-edicion",
  "ListadoElementosSinDatamatrixProcesado": "/listado-elementos-sin-datamatrix-procesado",
  "ListadoItfMadrugada": "/listado-itf-madrugada",
  "ListadoMaCapaElemento": "/listado-ma-capa-elemento",
  "ListadoMaestroAgrupacionesTipeqstar": "/listado-maestro-agrupaciones-tipeqstar",
  "ListadoMaestroAnMotivosAnulacion": "/listado-maestro-an-motivos-anulacion",
  "ListadoMaestroAnTipoAnomalia": "/listado-maestro-an-tipo-anomalia",
  "ListadoMaestroAnTipoFoto": "/listado-maestro-an-tipo-foto",
  "ListadoMaestroClaseActividad": "/listado-maestro-clase-actividad",
  "ListadoMaestroClaseOrden": "/listado-maestro-clase-orden",
  "ListadoMaestroCordenesCactividad": "/listado-maestro-cordenes-cactividad",
  "ListadoMaestroDocumentacion": "/listado-maestro-documentacion",
  "ListadoMaestroEstadoAviso": "/listado-maestro-estado-aviso",
  "ListadoMaestroEstados": "/listado-maestro-estados",
  "ListadoMaestroExepcionesDatamatrix": "/listado-maestro-exepciones-datamatrix",
  "ListadoMaestroGradoHumedad": "/listado-maestro-grado-humedad",
  "ListadoMaestroListados": "/listado-maestro-listados",
  "ListadoMaestroMetodosMedida": "/listado-maestro-metodos-medida",
  "ListadoMaestroMotivosNoMedicion": "/listado-maestro-motivos-no-medicion",
  "ListadoMaestroPropiedades": "/listado-maestro-propiedades",
  "ListadoMaestroRazonesInterrupcion": "/listado-maestro-razones-interrupcion",
  "ListadoMaestroRazonesRechazo": "/listado-maestro-razones-rechazo",
  "ListadoMaestroRecEstados": "/listado-maestro-rec-estados",
  "ListadoMaestroRegion": "/listado-maestro-region",
  "ListadoMaestroRiesgo": "/listado-maestro-riesgo",
  "ListadoMaestroTipoFormulario": "/listado-maestro-tipo-formulario",
  "ListadoMaestroTipoFotos": "/listado-maestro-tipo-fotos",
  "ListadoMaestroTipoMotivosAviso": "/listado-maestro-tipo-motivos-aviso",
  "ListadoMaestroTipoTerreno": "/listado-maestro-tipo-terreno",
  "ListadoMaestroTiposCierre": "/listado-maestro-tipos-cierre",
  "ListadoMaestroTrabtip": "/listado-maestro-trabtip",
  "ListadoMaestroZdaccion": "/listado-maestro-zdaccion",
  "ListadoMaestroZdactuacion": "/listado-maestro-zdactuacion",
  "ListadoMaestroZdcausastg": "/listado-maestro-zdcausastg",
  "ListadoMaestroZdequsgt": "/listado-maestro-zdequsgt",
  "ListadoMaestroZdgtipinc": "/listado-maestro-zdgtipinc",
  "ListadoMaestroZdptca": "/listado-maestro-zdptca",
  "ListadoMaestroZdptda": "/listado-maestro-zdptda",
  "ListadoMaestroZdptpdc": "/listado-maestro-zdptpdc",
  "ListadoMaestroZdrelacDiagno": "/listado-maestro-zdrelac-diagno",
  "ListadoMaestroZdsglobal": "/listado-maestro-zdsglobal",
  "ListadoMaestroZdsgtipinc": "/listado-maestro-zdsgtipinc",
  "ListadoMaestroZdsolustg": "/listado-maestro-zdsolustg",
  "ListadoMaestroZdtipinc": "/listado-maestro-zdtipinc",
  "ListadoMaestroZdtipodiag": "/listado-maestro-zdtipodiag",
  "ListadoOperacioneshr": "/listado-operacioneshr",
  "ListadoOtEstados": "/listado-ot-estados",
  "ListadoOtEstadosScript": "/listado-ot-estados-script",
  "ListadoRelacionBrigadas": "/listado-relacion-brigadas",
  "ListadoTipoUsuarios": "/listado-tipo-usuarios",
  "ListadoUsuariosAccesos": "/listado-usuarios-accesos",
  "LoginColl": "/login-coll",
  "MaestroAnMotivosAnulacion": "/maestro-an-motivos-anulacion",
  "MaestroClaseActividad": "/maestro-clase-actividad",
  "MaestroClaseOrden": "/maestro-clase-orden",
  "MaestroRazonesInterrupcion": "/maestro-razones-interrupcion",
  "MaestroRazonesRechazo": "/maestro-razones-rechazo",
  "MaestroVETensDiseVl": "/maestro-ve-tens-dise-vl",
  "MaestroVETipGrconextrafoVl": "/maestro-ve-tip-grconextrafo-vl",
  "MaestroVtECeldaMd": "/maestro-vt-e-celda-md",
  "MaestroVtECuadrobtMd": "/maestro-vt-e-cuadrobt-md",
  "MaestrovbbrigadavlScript": "/maestrovbbrigadavl-script",
  "MasterReplicaQueue": "/master-replica-queue",
  "MasterReplicaQueueSeq": "/master-replica-queue-seq",
  "MenuAdministrarUsuarios": "/menu-administrar-usuarios",
  "MenuAnMotivosAnulacion": "/menu-an-motivos-anulacion",
  "MenuAnTipoAnomalia": "/menu-an-tipo-anomalia",
  "MenuAnTipoFoto": "/menu-an-tipo-foto",
  "MenuAnomaliasConFotosPendientes": "/menu-anomalias-con-fotos-pendientes",
  "MenuAvisosMedioambientales": "/menu-avisos-medioambientales",
  "MenuDispositivos": "/menu-dispositivos",
  "MenuEdicionOt": "/menu-edicion-ot",
  "MenuITFMadrugada": "/menu-itf-madrugada",
  "MenuLogApi": "/menu-log-api",
  "MenuLogApiHistory": "/menu-log-api-history",
  "MenuMaCapaElemento": "/menu-ma-capa-elemento",
  "MenuMaestroAgrupacionesTipeqstar": "/menu-maestro-agrupaciones-tipeqstar",
  "MenuMaestroClaseActividad": "/menu-maestro-clase-actividad",
  "MenuMaestroClaseOrden": "/menu-maestro-clase-orden",
  "MenuMaestroCordenesCactividad": "/menu-maestro-cordenes-cactividad",
  "MenuMaestroDocumentacion": "/menu-maestro-documentacion",
  "MenuMaestroEstadoAviso": "/menu-maestro-estado-aviso",
  "MenuMaestroEstados": "/menu-maestro-estados",
  "MenuMaestroExepcionesDatamatrix": "/menu-maestro-exepciones-datamatrix",
  "MenuMaestroFormulario": "/menu-maestro-formulario",
  "MenuMaestroGradoHumedad": "/menu-maestro-grado-humedad",
  "MenuMaestroListados": "/menu-maestro-listados",
  "MenuMaestroMetodosMedida": "/menu-maestro-metodos-medida",
  "MenuMaestroMotivosNoMedicion": "/menu-maestro-motivos-no-medicion",
  "MenuMaestroPropiedades": "/menu-maestro-propiedades",
  "MenuMaestroRazonesInterrupcion": "/menu-maestro-razones-interrupcion",
  "MenuMaestroRazonesRechazo": "/menu-maestro-razones-rechazo",
  "MenuMaestroRecEstados": "/menu-maestro-rec-estados",
  "MenuMaestroRegion": "/menu-maestro-region",
  "MenuMaestroRiesgos": "/menu-maestro-riesgos",
  "MenuMaestroTipoFotos": "/menu-maestro-tipo-fotos",
  "MenuMaestroTipoMotivosAviso": "/menu-maestro-tipo-motivos-aviso",
  "MenuMaestroTipoTerreno": "/menu-maestro-tipo-terreno",
  "MenuMaestroTiposCierre": "/menu-maestro-tipos-cierre",
  "MenuMaestroTrabtip": "/menu-maestro-trabtip",
  "MenuMaestroZdaccion": "/menu-maestro-zdaccion",
  "MenuMaestroZdactuacion": "/menu-maestro-zdactuacion",
  "MenuMaestroZdcausastg": "/menu-maestro-zdcausastg",
  "MenuMaestroZdequsgt": "/menu-maestro-zdequsgt",
  "MenuMaestroZdgtipinc": "/menu-maestro-zdgtipinc",
  "MenuMaestroZdptca": "/menu-maestro-zdptca",
  "MenuMaestroZdptda": "/menu-maestro-zdptda",
  "MenuMaestroZdptpdc": "/menu-maestro-zdptpdc",
  "MenuMaestroZdrelacDiagno": "/menu-maestro-zdrelac-diagno",
  "MenuMaestroZdsglobal": "/menu-maestro-zdsglobal",
  "MenuMaestroZdsgtipinc": "/menu-maestro-zdsgtipinc",
  "MenuMaestroZdsolustg": "/menu-maestro-zdsolustg",
  "MenuMaestroZdtipinc": "/menu-maestro-zdtipinc",
  "MenuMaestroZdtipodiag": "/menu-maestro-zdtipodiag",
  "MenuOperacioneshr": "/menu-operacioneshr",
  "MenuOtActivas": "/menu-ot-activas",
  "MenuOtsPendientesAceptarPorDispositivo": "/menu-ots-pendientes-aceptar-por-dispositivo",
  "MenuPDFsPorProcesar": "/menu-pd-fs-por-procesar",
  "MenuPadre": "/menu-padre",
  "MenuRelacionBrigadas": "/menu-relacion-brigadas",
  "MenuReprocesos": "/menu-reprocesos",
  "MenuTipoFormularios": "/menu-tipo-formularios",
  "MenuUsuariosAcciones": "/menu-usuarios-acciones",
  "MonitorAccionesScript": "/monitor-acciones-script",
  "MonitorAccionesUltimaAccion1": "/monitor-acciones-ultima-accion1",
  "OTEstadosEx": "/ot-estados-ex",
  "ObtenerTIpoCentroCT": "/obtener-t-ipo-centro-ct",
  "ObtenerTIpoCentroCTC": "/obtener-t-ipo-centro-ctc",
  "OperacionesQueueUltimaHora": "/operaciones-queue-ultima-hora",
  "OperacionesTotalesQUEUE": "/operaciones-totales-queue",
  "OperacionesTotalesSQUEUE": "/operaciones-totales-squeue",
  "PdfConMas10minutosSinGenerar": "/pdf-con-mas10minutos-sin-generar",
  "ProvisioningTaskScript": "/provisioning-task-script",
  "RelacionBrigadasScript": "/relacion-brigadas-script",
  "ReprocesadoGetColumns": "/reprocesado-get-columns",
  "ReprocesadoGetData": "/reprocesado-get-data",
  "RiOtPropiedadesActualizadas": "/ri-ot-propiedades-actualizadas",
  "RiPropiedadesMarcadas": "/ri-propiedades-marcadas",
  "TotalOperacionesPendAnalizar": "/total-operaciones-pend-analizar",
  "UltimoUsuariosAccesos": "/ultimo-usuarios-accesos",
  "ViewSelectivityDeviceScript": "/view-selectivity-device-script",
  "WebAccionesUsuario": "/web-acciones-usuario",
  "Empresas": "/empresas",
  "Usuarios": "/usuarios",
} as const;
